/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const BtnIcon = ({
  className,
  overlapGroupClassName,
  vectorClassName,
  vector = "/img/vector-7.svg",
  ellipseClassName,
  divClassName,
}) => {
  return (
    <div className={`btn-icon ${className}`}>
      <div className={`overlap-group-3 ${overlapGroupClassName}`}>
        <img
          className={`vector ${vectorClassName}`}
          alt="Vector"
          src={vector}
        />

        <div className={`ellipse ${ellipseClassName}`} />

        <div className={`text-wrapper-5 ${divClassName}`}>+9</div>
      </div>
    </div>
  );
};

BtnIcon.propTypes = {
  vector: PropTypes.string,
};
